import gsap from 'gsap';

const wordEls = document.querySelectorAll('.word');
const coda = document.querySelector('.coda');

// Split each word into individual letter spans
wordEls.forEach((wordEl) => {
  const letters = wordEl.textContent.split('');
  wordEl.textContent = '';
  letters.forEach((char) => {
    const span = document.createElement('span');
    span.textContent = char;
    span.style.display = 'inline-block';
    wordEl.appendChild(span);
  });
});

const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

gsap.set(coda, { y: 20, opacity: 0 });

wordEls.forEach((wordEl, i) => {
  const letters = wordEl.querySelectorAll('span');

  gsap.set(letters, { y: 40, opacity: 0, rotateX: -60 });

  tl.to(
    letters,
    {
      y: 0,
      opacity: 1,
      rotateX: 0,
      duration: 0.45,
      stagger: 0.05,
    },
    i === 0 ? 0.2 : '>+0.125'
  );
});

tl.to(
  coda,
  { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out' },
  '>+0.4'
);
